import { Content, Text, Anchor, Icon } from '@kinesis/bungle';
import { noop } from 'lodash/fp';

const DownloadLink = (props: DownloadLinkProps) => {
  const { downloading = false, onDownload = noop } = props;

  return (
    <Content padding='none'>
      <Text>
        <Anchor
          as='button'
          type='button'
          disabled={downloading}
          onClick={downloading ? noop : onDownload}
        >
          Download the complete data
        </Anchor>
        {downloading && (
          <>
            {' '}
            <Icon animation='rotate' magnitude='xsmall' type='spinner' />
          </>
        )}
        &nbsp;for more details and to compare this pathway with alternatives.
      </Text>
    </Content>
  );
};

export type DownloadLinkProps = {
  // The download is in flight — the link disables and a spinner sits beside
  // it until the signed URL is minted.
  downloading?: boolean;
  onDownload?: () => void;
};

export { DownloadLink };
